var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeBlock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.961,
    height: 16.466,
    viewBox: "1264.501 131 19.961 16.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "noun-hidden-7454999"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1284.322 138.789c-.189-.21-4.433-5.504-9.832-5.504-1.07 0-2.101.21-3.067.547l1.134 1.134a7.522 7.522 0 0 1 1.933-.273c3.866 0 7.248 3.319 8.34 4.538a17.881 17.881 0 0 1-3.235 2.793l1.03 1.03c2.184-1.492 3.592-3.236 3.676-3.361a.756.756 0 0 0 .021-.904Z",
    fillRule: "evenodd",
    "data-name": "Path 10829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.49 136.058c-.252 0-.504.042-.756.084l3.823 3.824c.063-.232.084-.484.084-.756.021-1.744-1.407-3.152-3.15-3.152Z",
    fillRule: "evenodd",
    "data-name": "Path 10830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267.2 131.205a.697.697 0 1 0-.987.987l2.794 2.794c-2.542 1.555-4.222 3.656-4.349 3.782a.696.696 0 0 0 0 .883c.19.252 4.433 5.525 9.832 5.525 1.366 0 2.669-.337 3.824-.84l2.92 2.92c.147.147.316.21.504.21a.683.683 0 0 0 .504-.21.697.697 0 0 0 0-.988l-15.042-15.063Zm7.29 12.563c-3.866 0-7.248-3.319-8.34-4.538.65-.714 2.058-2.121 3.886-3.193l1.68 1.68a3.066 3.066 0 0 0-.398 1.513 3.183 3.183 0 0 0 3.172 3.173c.547 0 1.071-.147 1.513-.4l1.219 1.22c-.862.335-1.786.545-2.732.545Z",
    fillRule: "evenodd",
    "data-name": "Path 10831"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBlock);
export default __webpack_public_path__ + "static/media/eye-block.a7c9635ac0aea83cb75a2c1f49c28e7f.svg";
export { ForwardRef as ReactComponent };